import classNames from 'classnames';
import useSize from 'hooks/useSize';
import React, { useRef } from 'react';

const propTypes = {};

const SectionLabelContainer = ({ className, style, children, onClick, id }) => {
  //! State
  const refContainer = useRef();
  const size = useSize(refContainer);

  //! Function

  //! Render
  return (
    <div
      ref={refContainer}
      className={classNames(className || 'position-relative pl-3')}
      style={style}
      onClick={onClick}
      id={id}
    >
      <div
        style={{ position: 'absolute', left: 0, top: -2, width: 4, height: size?.height || 0 }}
        className='bg-color-danger-v2'
      />
      {children}
    </div>
  );
};

SectionLabelContainer.propTypes = propTypes;
export default React.memo(SectionLabelContainer);
